:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-lar3294{gap:var(--t-space-large);}
:root ._items-center{align-items:center;}
:root ._grow-1{flex-grow:1;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}